/**
 * Moving one item of a list, which is the whole of reordering.
 *
 * One implementation because there are several lists: the exercises in a
 * session, the tests in a club's catalogue, and whatever comes next. Written by
 * hand each time it is the same four lines and the same two off-by-ones — a
 * swap that silently does nothing at the ends, or one that wraps a top item
 * round to the bottom.
 */
export function moveItem<T>(items: readonly T[], from: number, to: number): T[] {
  const next = [...items];
  // Out of range is a no-op, not a wrap and not a throw: the caller is a button
  // at the end of a list, and the honest answer to "move the first one up" is
  // that nothing happens.
  if (from < 0 || from >= next.length || to < 0 || to >= next.length || from === to) {
    return next;
  }
  const [moved] = next.splice(from, 1);
  next.splice(to, 0, moved as T);
  return next;
}

/** Whether a move is possible, so a button can say so before it is pressed. */
export function canMove(index: number, count: number, by: -1 | 1): boolean {
  const to = index + by;
  return index >= 0 && index < count && to >= 0 && to < count;
}
